var map = {
	"./new-home-page-guide-drawer-illustration-en1.png": 1265,
	"./new-home-page-guide-drawer-illustration-en2.png": 1266,
	"./new-home-page-guide-drawer-illustration-en3.png": 1267,
	"./new-home-page-guide-drawer-illustration-en4.png": 1268,
	"./new-home-page-guide-drawer-illustration-en5.png": 1269,
	"./new-home-page-guide-drawer-illustration-fr1.png": 1270,
	"./new-home-page-guide-drawer-illustration-fr2.png": 1271,
	"./new-home-page-guide-drawer-illustration-fr3.png": 1272,
	"./new-home-page-guide-drawer-illustration-fr4.png": 1273,
	"./new-home-page-guide-drawer-illustration-fr5.png": 1274
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1264;